






































import Vue, { PropType } from 'vue'
import CClassifiedList from '~/components/shared/configurable/classified/list/CClassifiedList.vue'
import { faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons'
import { Classified } from '~/models/classified/types'
import vClickOutside from 'v-click-outside'

export default Vue.extend({
  directives: { clickOutside: vClickOutside.directive },
  components: { CClassifiedList },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    classified: {
      type: Object as PropType<Classified>,
      required: true
    }
  },
  computed: {
    icons() {
      return {
        info: faInfoCircle,
        close: faTimes
      }
    }
  },
  methods: {
    onPopoverShow() {
      const { classifiedsLists } = this.$refs
      classifiedsLists.setInputFocus()
      classifiedsLists.initList()
    },
    onInfoClick() {
      const { classifiedsLists } = this.$refs
      classifiedsLists.onInfoClick()
      classifiedsLists.onCloseForm()
    },
    closeList() {
      const { classifiedsLists } = this.$refs
      classifiedsLists.onClose()
      this.$emit('close-click')
    }
  }
})
